import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/db6g3trghk82orf0cl7g";

type Status = "idle" | "sending" | "success" | "error";

export default function ContactForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      const text = String(value).trim();
      if (text) payload.append(key, text);
    });

    setStatus("sending");
    setFormError("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || "";
      const isSpam = serverMsg.toLowerCase().includes("spam");
      const ok = response.ok && parsed?.code === "OK" && !isSpam;

      if (ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，提交失败，请稍后重试。");
    }
  };

  return (
    <form
      data-readdy-form
      id="yushuwu-feedback-form"
      onSubmit={handleSubmit}
      className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <label className="flex flex-col gap-2">
          <span className="text-sm text-foreground-700">您的称呼</span>
          <input
            name="name"
            type="text"
            required
            placeholder="请输入姓名或昵称"
            className="rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
          />
        </label>
        <label className="flex flex-col gap-2">
          <span className="text-sm text-foreground-700">联系邮箱</span>
          <input
            name="email"
            type="email"
            required
            placeholder="name@example.com"
            className="rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
          />
        </label>
      </div>

      <label className="mt-4 flex flex-col gap-2">
        <span className="text-sm text-foreground-700">反馈类型</span>
        <select
          name="type"
          defaultValue="内容建议"
          className="rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
        >
          <option value="内容建议">内容建议</option>
          <option value="使用问题">使用问题</option>
          <option value="版权相关">版权相关</option>
          <option value="合作洽谈">合作洽谈</option>
          <option value="其他反馈">其他反馈</option>
        </select>
      </label>

      <label className="mt-4 flex flex-col gap-2">
        <span className="text-sm text-foreground-700">反馈内容</span>
        <textarea
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="请描述你的建议或遇到的问题（500 字以内）"
          className="resize-none rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
        ></textarea>
      </label>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-honey-item"
      />

      {status === "success" && (
        <p className="mt-4 flex items-center gap-2 rounded-md bg-primary-50 px-4 py-3 text-sm text-primary-700">
          <i className="ri-checkbox-circle-line text-base"></i>
          提交成功，感谢你的反馈，我们会尽快处理。
        </p>
      )}
      {status === "error" && (
        <p className="mt-4 flex items-center gap-2 rounded-md bg-accent-50 px-4 py-3 text-sm text-accent-700">
          <i className="ri-error-warning-line text-base"></i>
          {formError}
        </p>
      )}

      <button
        type="submit"
        disabled={status === "sending"}
        className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 disabled:opacity-60 sm:w-auto"
      >
        {status === "sending" ? (
          <>
            <i className="ri-loader-4-line animate-spin"></i>
            提交中...
          </>
        ) : (
          <>
            <i className="ri-send-plane-line"></i>
            提交反馈
          </>
        )}
      </button>
    </form>
  );
}